import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route
} from 'react-router-dom';

// public pages
import HomePage from '../src/pages/HomePage/HomePage.jsx';
import ForgotPassword from '../src/pages/OldPages/ForgotPassword/ForgotPassword.jsx';
import ResetPassword from '../src/pages/OldPages/ForgotPassword/ResetPassword.jsx';
import PrivacyPolicy from '../src/pages/Legal/PrivacyPolicy.jsx';
import TermsOfService from '../src/pages/Legal/TermsOfService.jsx';
import CommunityGuidelines from '../src/pages/Legal/CommunityGuidelines.jsx';

// admin pages
import AdminLogin from '../src/pages/AdminLogin/AdminLogin.jsx';
import AdminInquiries from '../src/pages/AdminInquiries/AdminInquiries.jsx';
import AdminReports from '../src/pages/AdminReports/AdminReports.jsx';
import AdminLayout from '../src/pages/AdminLayout/AdminLayout.jsx';
import AdminDashboard from '../src/pages/AdminDashboard/AdminDashboard.jsx';
import AdminCourses from '../src/pages/AdminCourses/AdminCourses.jsx';
import AdminCourseForm from '../src/pages/AdminCourseForm/AdminCourseForm.jsx';
import AdminCourseDetail from '../src/pages/AdminCourseDetail/AdminCourseDetail.jsx';
import AdminEvents from '../src/pages/AdminEvents/AdminEvents.jsx';
import AdminEventForm from '../src/pages/AdminEvents/AdminEventForm.jsx';
import AdminEventDetail from '../src/pages/AdminEvents/AdminEventDetail.jsx';
import AdminPartners from '../src/pages/AdminPartners/AdminPartners.jsx';
import AdminPartnerForm from '../src/pages/AdminPartnerForm/AdminPartnerForm.jsx';
import AdminPartnerDetail from '../src/pages/AdminPartnerDetail/AdminPartnerDetail.jsx';
import AdminMembers from '../src/pages/AdminMembers/AdminMembers.jsx';
import AdminMemberDetail from '../src/pages/AdminMemberDetail/AdminMemberDetail.jsx';

// protected route wrapper
import ProtectedAdminRoute from '../src/pages/ProtectedAdminRoute/ProtectedAdminRoute.jsx';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route
          path="/"
          element={<HomePage />}
        />

        <Route
          path="/forgot-password"
          element={<ForgotPassword />}
        />

        <Route
          path="/reset-password"
          element={<ResetPassword />}
        />

        {/* Legal Routes */}
        <Route
          path="/privacy-policy"
          element={<PrivacyPolicy />}
        />

        <Route
          path="/terms-of-service"
          element={<TermsOfService />}
        />

        <Route
          path="/community-guidelines"
          element={<CommunityGuidelines />}
        />

        {/* Admin Login */}
        <Route
          path="/admin"
          element={<AdminLogin />}
        />

        {/* Protected Admin Area */}
        <Route
          element={
            <ProtectedAdminRoute>
              <AdminLayout />
            </ProtectedAdminRoute>
          }
        >
          <Route
            path="/admin/dashboard"
            element={<AdminDashboard />}
          />

          <Route
            path="/admin/inquiries"
            element={<AdminInquiries />}
          />

          <Route
            path="/admin/reports"
            element={<AdminReports />}
          />
          <Route
            path="/admin/courses"
            element={<AdminCourses />}
          />

          <Route
            path="/admin/courses/new"
            element={<AdminCourseForm />}
          />

          <Route
            path="/admin/courses/:id"
            element={<AdminCourseDetail />}
          />

          <Route
            path="/admin/courses/:id/edit"
            element={<AdminCourseForm />}
          />

          <Route
            path="/admin/events"
            element={<AdminEvents />}
          />

          <Route
            path="/admin/events/new"
            element={<AdminEventForm />}
          />

          <Route
            path="/admin/events/:id"
            element={<AdminEventDetail />}
          />

          <Route
            path="/admin/events/:id/edit"
            element={<AdminEventForm />}
          />
       <Route
          path="/admin/partners"
          element={<AdminPartners />}
        />

        <Route
          path="/admin/partners/new"
          element={<AdminPartnerForm />}
        />

        <Route
          path="/admin/partners/:id"
          element={<AdminPartnerDetail />}
        />

        <Route
          path="/admin/partners/:id/edit"
          element={<AdminPartnerForm />}
        />

        <Route
          path="/admin/members"
          element={<AdminMembers />}
        />

        <Route
          path="/admin/members/:id"
          element={<AdminMemberDetail />}
        />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}